import httpClient from "@plugins/http";
import appConfigs from "@configs/app";
import { ApiResponse } from "@apis/api.ts";

interface QuestionHasContentMapsResponseModel {
  hasContentMaps: boolean;
}

export default {
  /**
   * Fetch Question data
   * @param {*} uuid
   */
  fetchQuestion(uuid) {
    return httpClient.get(`/apis/question/${uuid}`);
  },
  /**
   * Fetch Questions data
   * @param {*} uuids
   */
  fetchQuestions(requestData) {
    return httpClient.get(`/apis/question`, {
      params: {
        uuids: requestData,
      },
    });
  },
  /**
   * Save Question
   * @param {*} uuid
   * @param {*} requestData
   */
  saveQuestion(uuid, requestData) {
    return httpClient.post(`/apis/question/save/${uuid}`, requestData, {
      headers: {
        "X-With-Richtext": true,
      },
    });
  },
  /**
   * Save Question Speech Evaluation
   * @param {*} uuid
   * @param {*} requestData
   */
  saveQuestionSpeechEvaluation(uuid, requestData) {
    const formData = new FormData();
    formData.append("gradingRubricUuid", requestData.rubricUuid);
    formData.append("language", requestData.language);
    return httpClient.post(`/apis/question/speech-evaluation/save/${uuid}`, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  /**
   * Create Question
   * @param {*} requestData
   */
  createQuestion(requestData) {
    return httpClient.post(`/apis/question/create`, requestData, {
      headers: {
        "X-With-Richtext": true,
      },
    });
  },
  /**
   * Save Question
   * @param {*} uuid
   * @param {*} requestData
   */
  saveQuestionSettings(uuid, requestData) {
    return httpClient.post(`/apis/question/settings/save/${uuid}`, requestData);
  },
  /**
   * Duplicate Question
   * @param {*} requestData
   */
  duplicateQuestion(requestData) {
    return httpClient.post(`/apis/question/duplicate`, requestData);
  },
  /**
   * Delete Question
   * @param {*} uuid
   */
  deleteQuestion(uuid) {
    return httpClient.post(`/apis/question/delete/${uuid}`);
  },
  /**
   * Delete Question
   * @param {*} requestData - List of <uuids>
   */
  deleteQuestions(requestData) {
    return httpClient.post(`/apis/question/delete`, requestData);
  },
  reorderMpqQuestion(params) {
    return httpClient.post(`/apis/question/reordermpq`, params);
  },
  getQuestionImageBlob(path) {
    return httpClient.get(`${appConfigs.s3ResourceDomain}/question/${path}`, {
      withCredentials: true,
      responseType: "blob",
    });
  },
  getQuestionHint(params) {
    return httpClient.get(`/apis/question/hint`, {
      params: params,
    });
  },
  // Returns boolean if the single question have content map taggings.
  getQuestionHasContentMaps(
    questionId: number,
  ): Promise<ApiResponse<QuestionHasContentMapsResponseModel>> {
    return httpClient.get(`/apis/question/has-content-maps`, {
      params: { questionId },
    });
  },
};
